import { render, staticRenderFns } from "./TabelaPrecificacao.vue?vue&type=template&id=12e426be&"
import script from "./TabelaPrecificacao.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecificacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPrecificacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports